import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import {initAmountForPremiumSavingsAd} from '@Components/premium-savings-ad-text/premium-savings-ad-text-thunk';
import type {PremiumSavingsAdAmount} from '@Components/premium-savings-ad-text/premium-savings-ad-text.types';

const initialState: PremiumSavingsAdAmount = {formattedAmount: null};

export const premiumSavingsAdSlice = createSlice({
  name: 'premiumSavingsAd',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initAmountForPremiumSavingsAd.fulfilled, (state, {payload}: PayloadAction<PremiumSavingsAdAmount>) => {
      state.formattedAmount = payload.formattedAmount;
    });
  },
});

export const {} = premiumSavingsAdSlice.actions;
export const premiumSavingsAdReducer = premiumSavingsAdSlice.reducer;
